import { render, staticRenderFns } from "./CeremonyHighlightCollections.vue?vue&type=template&id=9e490dce&scoped=true"
import script from "./CeremonyHighlightCollections.vue?vue&type=script&lang=js"
export * from "./CeremonyHighlightCollections.vue?vue&type=script&lang=js"
import style0 from "./CeremonyHighlightCollections.vue?vue&type=style&index=0&id=9e490dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e490dce",
  null
  
)

export default component.exports